<a [attr.href]="url ? url : null" [target]="template === 'external' ? '_blank' : '_self'">
  <div class="article-image-card -container" [ngClass]="landscape ? '-landscape' : '-portrait'">
    <div class="article-image-card -content-image">
      <img [src]="image">
    </div>
    <div class="article-image-card -content-info" [ngClass]="type !== 'news' ? '-events' : ''">
      <ng-content></ng-content>
    </div>
  </div>
</a>